const initials = "examSchedule/";

export const UPDATE_EXAM_SCHEDULE = `${initials}UPDATE_EXAM_SCHEDULE`;

export const UPDATE_EXAM_SCHEDULE_HISTORY = `${initials}UPDATE_EXAM_SCHEDULE_HISTORY`;
